<ion-header>
  <ion-toolbar>
    <div class="custom-title">Want reminders?</div>
  </ion-toolbar>
</ion-header>

<div class="modal-body">
  <div class="modal-content">
    <div class="notification-icon">
      <ion-icon name="notifications-outline"></ion-icon>
    </div>

    <ion-text class="info-text">
      <p class="main-message">
        Some people like occasional nudges to log food and stay on track.
      </p>
      <p class="sub-message">
        We'll keep it light — and you'll be able to customize this soon.
      </p>
    </ion-text>

    <div class="button-group">
      <ion-button expand="block" (click)="onEnableNotifications()" class="enable-button">
        Enable Notifications
      </ion-button>
      <ion-button expand="block" fill="outline" (click)="onNotNow()" class="not-now-button">
        Not Now
      </ion-button>
    </div>
  </div>
</div>
